<template>
  <div>
    <footer>
      <div class="container-fluid">
        <div class="footer-content">
          <div class="footer-logo">
            <img :src="logo.logo" class="img-fluid" alt="Logo" />
            <div class="text text-uppercase">
              International<br />
              Academy for <br />
              Homeland<br />
              Security
            </div>
          </div>
          <div class="footer-links">
            <router-link
              class="footer-link"
              v-if="header[0] ? header[0].status : false"
              to="/accreditations"
              >Accreditation</router-link
            >

            <router-link
              class="footer-link"
              v-if="header[8] ? header[8].status : false"
              to="/our-certificates"
              >Certification</router-link
            >

            <router-link
              class="footer-link"
              v-if="header[3] ? header[3].status : false"
              to="/about"
              >About</router-link
            >

            <router-link
              class="footer-link"
              v-if="header[1] ? header[1].status : false"
              to="/programs"
              >Programs</router-link
            >

            <router-link
              class="footer-link"
              v-if="header[2] ? header[2].status : false"
              to="/memberships"
              >Membership</router-link
            >

            <router-link
              class="footer-link"
              v-if="header[4] ? header[4].status : false"
              to="/contact"
              >Contact us</router-link
            >

            <router-link
              class="footer-link"
              v-if="header[7] ? header[7].status : false"
              to="/online-trainings"
              >Online Training</router-link
            >

            <router-link
              class="footer-link"
              v-if="header[6] ? header[6].status : false"
              to="/events"
              >Events &amp; Conferences</router-link
            >

            <router-link
              v-for="(pg, idx) in pages"
              :key="idx"
              :to="{ name: 'show-page', params: { slug: pg.slug } }"
              class="footer-link"
              :class="pg.has_footer ? '' : 'hidden'"
            >
              {{ pg.title }}</router-link
            >
          </div>
        </div>
        <div class="footer-bottom d-flex justify-content-between">
          <div class="fb-text">
            2021 All Rights Reserved © IAHS International Academy for Homeland
            Security
            <router-link
              class="privacy-btn ml-2"
              v-if="header[5] ? header[5].status : false"
              to="/privacy"
              >Privacy Policy
            </router-link>
          </div>
          <div class="socialmedia d-flex align-items-center">
            <div class="follow-text mr-3">Follow us</div>
            <div class="footer-socialmedia">
              <a
                v-for="(social, index) in rows"
                class="facebook-icon social-icon"
                :href="social.provider_url"
                target="_blank"
                :key="index"
              >
                <i
                  v-if="social.provider.toLowerCase() == 'facebook'"
                  class="fab fa-facebook-f"
                ></i>
                <i
                  v-if="social.provider.toLowerCase() == 'youtube'"
                  class="fab fa-youtube"
                ></i>
                <i
                  v-if="social.provider.toLowerCase() == 'linkedin'"
                  class="fab fa-linkedin-in"
                ></i>
                <i
                  v-if="social.provider.toLowerCase() == 'twitter'"
                  class="fab fa-twitter"
                ></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<style scoped>
/* Footer */
footer {
  background: #151534;
  padding: 50px 0 0;
}
footer .footer-content {
  border-top: 1px solid #bd9d49;
  border-bottom: 1px solid #bd9d49;
  display: flex;
}
footer div,
footer span,
footer i,
footer a {
  color: #437aa3;
}
footer .bg-title {
  color: #437aa3;
}
.footer-logo {
  padding: 25px 0;
  padding-right: 15px;
  display: flex;
  border-right: 1px solid #bd9d49;
  width: 280px;
}
.footer-logo img {
  width: 80px;
}
.footer-logo .text {
  font-size: 18px;
  line-height: 1.1;
  color: #fff;
  padding-top: 5px;
  padding-left: 13px;
}
.footer-links {
  padding: 25px 20px;
  padding-left: 40px;
}
.footer-link {
  margin-right: 30px;
  font-size: 18px;
  display: inline-block;
  color: #fff;
}
.footer-link:hover {
  color: #c0a04a;
}
.fb-text {
  font-size: 16px;
  display: flex;
  align-items: center;
  color: #757598;
}
.fb-text a {
  text-decoration: underline !important;
}
.fb-text a:hover {
  color: #fff;
}
.follow-text {
  line-height: 1;
  font-size: 16px;
  color: #fff;
}
.socialmedia i {
  font-size: 16px;
  margin-left: 14px;
  color: #fff;
}
.socialmedia i:hover {
  color: #c0a04a;
}
.footer-bottom {
  padding: 15px 0;
}
.privacy-btn {
  color: #757598;
}
/* Footer */
/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
}

@media (max-width: 767.98px) {
  /* Footer */
  footer {
    padding: 10px 0 0;
  }
  .footer-logo {
    border-right: none;
  }
  .footer-bottom,
  .fb-text {
    display: block !important;
  }
  .footer-links {
    padding: 10px 0;
  }
  footer .footer-content {
    border-top: none;
    flex-wrap: wrap;
  }
  .footer-logo {
    width: 100%;
    padding: 25px 0 10px;
  }
  .footer-logo {
    align-items: center;
  }
  /* Footer */
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  /* Footer */
  .footer-logo {
    border-right: none;
    width: 510px;
  }
  .footer-links {
    padding-left: 0;
    padding-right: 0;
  }
  .footer-bottom {
    display: block !important;
  }
  .footer-link {
    margin-right: 18px;
  }
  /* Footer */
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
  /* Footer */
  footer .footer-content {
    flex-wrap: nowrap;
  }
  .footer-links {
    width: calc(100% - 260px);
  }
  .footer-logo {
    /* width: auto; */
  }
  /* Footer */
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
}
</style>

<script>
import axios from "axios";
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      rows: [],
      header: [],
      pages: [],
      logo: [],
    };
  },
  created() {
    axios
      .get(window.baseURL + "/setting")
      .then((res) => {
        this.rows = res.data.social;
        this.header = res.data.header;
        this.logo = res.data.logo;
      })
      .catch(() => {});

    axios
      .get(window.baseURL + "/pages")
      .then((res) => {
        var data = res.data.rows;
        this.pages = res.data.rows;
      })
      .catch(() => {});
  },
};
</script>
